import * as React from 'react';

import classnames from 'classnames';

import {RemoveButton} from '../button/remove-button/remove-button';
import {Dialog} from '../dialog/dialog';

import {getEntityClassName} from './helpers';
import type {SectionEntity} from './types';

import styles from './section-item.module.css';

type Props = {
    sectionEntity: SectionEntity;
    itemHeaderComponent: React.ReactNode;
    onClickRemove: (arg1?: any) => Promise<any>;
    removeConfirmationText: string;
    content?: React.ReactNode;
};

export function SectionItem(props: Props) {
    const {sectionEntity, itemHeaderComponent, onClickRemove, removeConfirmationText, content} =
        props;

    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const [isDisabled, setIsDisabled] = React.useState<boolean>(false);

    const deleteButtonRef = React.useRef(null);

    const styleNames = classnames({
        [styles['section-item']]: true,
        [styles['section-item--disabled']]: isDisabled,
        ...getEntityClassName(sectionEntity),
    });

    return (
        <>
            <div className={styleNames}>
                <div className={styles['item-header-container']}>
                    <div className={styles['item-header']}>{itemHeaderComponent}</div>
                    <div className={styles['remove-button-container']}>
                        <RemoveButton
                            size={10}
                            onClick={() => {
                                setIsConfirmingDelete(true);
                            }}
                            getButtonRef={deleteButtonRef}
                        />
                    </div>
                </div>
                {content ? <div className={styles['content-container']}>{content}</div> : undefined}
            </div>
            {isConfirmingDelete ? (
                <Dialog
                    anchor={deleteButtonRef.current}
                    question={removeConfirmationText}
                    primaryText='Yes, remove'
                    secondaryText='No, don’t remove'
                    onPrimary={() => {
                        setIsDisabled(true);
                        setIsConfirmingDelete(false);

                        // Reset if remove fails
                        onClickRemove().catch(() => {
                            setIsDisabled(false);
                        });
                    }}
                    onSecondary={() => {
                        setIsConfirmingDelete(false);
                    }}
                    isWarning={true}
                />
            ) : undefined}
        </>
    );
}
